import AcessoNegado from '@/components/AcessoNegado/acessoNegado.en-us.i18n.json'
import ChatPoliticas from '@/components/ChatPoliticas/chatPoliticas.en-us.i18n.json'
import ConexoesMcp from '@/typescript/modulos/governanca/ConexoesMcp/conexoesMcp.en-us.i18n.json'
import AssistentePontotel from '@/typescript/modulos/governanca/AssistentePontotel/assistentePontotel.en-us.i18n.json'
import AcompanhamentoTempoReal from '@/components/AcompanhamentoTempoReal/acompanhamentoTempoReal.en-us.i18n.json'
import Cognito from '@/components/Cognito/cognito.en-us.i18n.json'
import CentralAtendimento from '@/components/CentralAtendimento/centralAtendimento.en-us.i18n.json'
import Compartilhados from '@/common/compartilhados.en-us.i18n.json'
import Bora from '@/common/Bora/bora.en-us.i18n.json'
import MainHeader from '@/components/MainHeader/mainHeader.en-us.i18n.json'
import MenuLateral from '@/common/MenuLateral/menuLateral.en-us.i18n.json'
import ControleDeEstacoes from '@/components/ControleDeEstacoes/controleDeEstacoes.en-us.i18n.json'
import Home from '@/components/Home/home.en-us.i18n.json'
import router from '@/router/router.en-us.i18n.json'
import Utils from '@/utils/utils.en-us.i18n.json'
import Reports from '@/components/Reports/reports.en-us.i18n.json'
import Solicitacao from '@/components/Approvals/i18n/solicitacao.en-us.i18n.json'
import RegraAprovacao from '@/components/ApprovalsRules/regraAprovacao.en-us.i18n.json'
import Empregado from '@/components/Employee/employee.en-us.i18n.json'
import Empregador from '@/components/Employer/employer.en-us.i18n.json'
import LocalDeTrabalho from '@/components/Company/local.en-us.i18n.json'
import Permissions from '@/components/Permissions/permissions.en-us.i18n.json'
import Groups from '@/components/Groups/groups.en-us.i18n.json'
import Reason from '@/components/Reason/reason.en-us.i18n.json'
import HourBankRules from '@/components/HourBankRules/hourBankRules.en-us.i18n.json'
import workSchedule from '@/components/WorkSchedule/workSchedule.en-us.i18n.json'
import Journey from '@/components/Journey/journey.en-us.i18n.json'
import CustomizacoesDeCalculo from '@/components/CustomizacoesDeCalculo/customizacao.en-us.i18n.json'
import LayoutE02 from '@/typescript/modulos/calculos-do-sistema/e02/layoutE02.en-us.i18n.json'
import Locker from '@/components/Locker/locker.en-us.i18n.json'
import Sheets from '@/components/Sheets/sheets.en-us.i18n.json'
import LockerRules from '@/components/LockerRules/lockerRules.en-us.i18n.json'
import MassChanges from '@/components/MassChanges/massChanges.en-us.i18n.json'
import LogDeOperacoes from '@/components/LogDeOperacoes/logDeOperacoes.en-us.i18n.json'
import FileManagement from '@/components/FileManagement/fileManagement.en-us.i18n.json'
import PainelDePontos from '@/components/PainelDePontos/paineldepontos.en-us.i18n.json'
import Holiday from '@/components/Holiday/holiday.en-us.i18n.json'
import ModuloRegrasDeFerias from '@/typescript/modulos/calendario-de-trabalho/RegrasDeFerias/i18n/regrasDeFerias.en-us.i18n.json'
import ModuloGerenciamentoDeFerias from '@/typescript/modulos/calendario-de-trabalho/GerenciamentoDeFerias/gerenciamentoDeFeria.en-us.i18n.json'
import CalendarioAloque from '@/typescript/modulos/calendario-de-trabalho/CalendarioAloque/calendarioAloque.en-us.i18n.json'
import FeriasEAfastamentos from '@/components/FeriasEAfastamentos/feriasEAfastamento.en-us.i18n.json'
import ModuloSolicitacoes from '@/typescript/modulos/governanca/solicitacoes/solicitacoes.en-us.i18n.json'
import PainelSolicitacoesDeHorasExtras from '@/typescript/modulos/acompanhamento/PainelSolicitacoesDeHorasExtras/painelSolicitacoesDeHorasExtras.en-us.i18n.json'
import Biometria from '@/components/FaceBiometric/facebiometric.en-us.i18n.json'
import BiometriaCadastro from '@/typescript/modulos/estrutura-de-pontos-da-empresa/biometria/apresentacao/biometria.en-us.i18n.json'
import Coletor from '@/components/Coletores/coletor.en-us.i18n.json'
import Dispositivos from '@/components/Devices/dispositivos.en-us.i18n.json'
import FarolDoDP from '@/components/FarolDoDP/farol-do-dp.en-us.i18n.json'
import Compman from '@/components/CompMan/compman.en-us.i18n.json'
import Auditoria from '@/components/Auditor/auditoria.en-us.i18n.json'
import User from '@/components/User/user.en-us.i18n.json'
import Faturas from '@/typescript/modulos/tiosam/faturas/faturas.en-us.i18n.json'
import tipos from '@/tipos/tipos.en-us.i18n.json'
import store from '@/store/store.en-us.i18n.json'
import typescript from '@/typescript/typescript.en-us.i18n.json'
import Comuns from '@/typescript/servicos/i18n/locales/comuns.en-us.i18n.json'
import Dashboards from '@/components/DashBoards/dashboards.en-us.i18n.json'
import Routine from '@/components/Routine/routine.en-us.i18n.json'
import Whb from '@/components/Whb/whb.en-us.i18n.json'
import ModuloFolha from '@/typescript/modulos/estrutura-de-pontos-da-empresa/Folha/folha.en-us.i18n.json'
import ParametrizadorE02 from '@/components/ParametrizadorE02/parametrizadorE02.en-us.i18n.json'
import CatalogoLocalDeTrabalho from '@next/modulos/estrutura-de-ponto-da-empresa/local-de-trabalho/catalogo/catalogo-local-de-trabalho.en-us.i18n.json'
import CatalogoRegraDeCalculo from '@next/modulos/folha-de-ponto/regra-de-calculo/catalogo/catalogo-regra-de-calculo.en-us.i18n.json'
import CatalogoEmpregador from '@next/modulos/estrutura-de-ponto-da-empresa/empregador/catalogo/catalogo-empregador.en-us.i18n.json'
import CatalogoEmpregado from '@next/modulos/estrutura-de-ponto-da-empresa/empregado/catalogo/catalogo-empregado.en-us.i18n.json'
import CatalogoMotivoPadrao from '@next/modulos/estrutura-de-ponto-da-empresa/motivo-padrao/catalogo/catalogo-motivo-padrao.en-us.i18n.json'
import CatalogoGrupoDeLocaisDeTrabalho from '@next/modulos/governanca/grupo-de-locais-de-trabalho/catalogo/catalogo-grupo-de-locais-de-trabalho.en-us.i18n.json'
import CatalogoPerfilDePermissao from '@next/modulos/governanca/perfil-de-permissao/catalogo/catalogo-perfil-de-permissao.en-us.i18n.json'
import CatalogoUsuario from '@next/modulos/governanca/usuario/catalogo/catalogo-usuario.en-us.i18n.json'

const mensagens: Record<string, any> = {
  ...ParametrizadorE02,
  words: {
    user: 'user | users',
    employee: 'employee | employees',
    company: 'work location | work locations',
    companyShortName: 'location | locations',
    employer: 'employer | employers',
    supervisor: 'supervisor | supervisors',
    routine: 'schedule | schedules',
    journey: 'journey | journeys',
    customRules: 'calculation rule | calculation rules',
    locker: 'lock | locks',
    group: 'group | groups',
    whbRules: 'time bank rule | time bank rules',
    all: 'apply to all'
  },
  acessoNegado: AcessoNegado,
  acompanhamentoTempoReal: AcompanhamentoTempoReal,
  cognito: Cognito,
  centralAtendimento: CentralAtendimento,
  compartilhados: Compartilhados,
  bora: Bora,
  mainHeader: MainHeader,
  MenuLateral: MenuLateral,
  controleDeEstacoes: ControleDeEstacoes,
  home: Home,
  router: router,
  utils: Utils,
  reports: Reports,
  solicitacao: Solicitacao,
  regraAprovacao: RegraAprovacao,
  empregado: Empregado,
  empregador: Empregador,
  local: LocalDeTrabalho,
  permissions: Permissions,
  groups: Groups,
  reason: Reason,
  hourBankRules: HourBankRules,
  workSchedule: workSchedule,
  journey: Journey,
  customizacoesDeCalculo: CustomizacoesDeCalculo,
  layoutE02: LayoutE02,
  locker: Locker,
  sheets: Sheets,
  lockerRules: LockerRules,
  massChanges: MassChanges,
  logDeOperacoes: LogDeOperacoes,
  fileManagement: FileManagement,
  paineldepontos: PainelDePontos,
  holiday: Holiday,
  regrasDeFerias: ModuloRegrasDeFerias,
  gerenciamentoDeFerias: ModuloGerenciamentoDeFerias,
  calendarioAloque: CalendarioAloque,
  feriasEAfastamento: FeriasEAfastamentos,
  solicitacoes: ModuloSolicitacoes,
  painelSolicitacoesDeHorasExtras: PainelSolicitacoesDeHorasExtras,
  biometria: { ...Biometria, ...BiometriaCadastro },
  coletor: Coletor,
  dispositivos: Dispositivos,
  farolDoDP: FarolDoDP,
  compman: Compman,
  auditoria: Auditoria,
  user: User,
  tiosam: { faturas: Faturas },
  tipos: tipos,
  store: store,
  typescript: typescript,
  comuns: Comuns,
  dashboards: Dashboards,
  routine: Routine,
  whb: Whb,
  folha: ModuloFolha,
  chatPoliticas: ChatPoliticas,
  conexoesMcp: ConexoesMcp,
  assistentePontotel: AssistentePontotel,
  srcNext: {
    folhaDePonto: {
      catalogoRegraDeCalculo: CatalogoRegraDeCalculo,
    },
    governanca: {
      catalogoGrupoDeLocaisDeTrabalho: CatalogoGrupoDeLocaisDeTrabalho,
      catalogoPerfilDePermissao: CatalogoPerfilDePermissao,
      catalogoUsuario: CatalogoUsuario
    },
    estruturaDePontoDaEmpresa: {
      catalogoLocalDeTrabalho: CatalogoLocalDeTrabalho,
      catalogoEmpregador: CatalogoEmpregador,
      catalogoEmpregado: CatalogoEmpregado,
      catalogoMotivoPadrao: CatalogoMotivoPadrao
    }
  }
}

export default mensagens
